import * as React from 'react'
import { Combobox } from '@base-ui/react/combobox'
import { twMerge } from 'tailwind-merge'
import type { PartProps } from '../../../lib/part-props'

interface ComboboxListProps extends PartProps<React.ComponentProps<typeof Combobox.List>> {
  className?: string
}

function ComboboxList({ className, children, ...props }: ComboboxListProps) {
  return (
    <Combobox.List className={twMerge('', className)} {...props}>
      {children}
    </Combobox.List>
  )
}

export { ComboboxList }
